import React from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useLocation } from 'react-router';
import { VersionState } from '../../../../types/api/VersionState';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';

/**
 * Info for screen reader users to make them aware of active editmode,
 * draft or paginated pages.
 *
 * The editMode takes precedence over all other cases, hence the order is:
 *  1. <Seitentitel> - Bearbeitungsmodus
 *  2. <Seitentitel> - Nicht veröffentlicht
 *  3. <Seitentitel> - Seite x von N
 */
export function PageLeadMetaInfo() {
  const { t } = useTranslation();
  const { editModeInfo, headMetaInfo } = useAppContext();
  const location = useLocation();

  const getMetaInfo = (): string | undefined => {
    if (editModeInfo.active) {
      return t('glossary:editMode');
    }
    if (headMetaInfo.versionState === VersionState.draft) {
      return t('glossary:draft');
    }

    if (headMetaInfo.versionState === VersionState.publishedHistory) {
      return t('glossary:publishedHistory');
    }

    if (headMetaInfo.pagination) {
      const { currentPage, totalPages } = headMetaInfo.pagination;
      return t('PageLead:pageCurrentOfTotal', {
        current: currentPage,
        total: totalPages,
      });
    }
  };

  const metainfo = getMetaInfo();
  const searchQuery = createSearchParams(location.search).get('q');
  return (
    metainfo && (
      <span className="invisible">{`${searchQuery ? `${t('glossary:by')} "${searchQuery}"` : ''} - ${metainfo}`}</span>
    )
  );
}
